/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHardrive = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 19.003c0 .55-.447.997-.997.997H4.997A.998.998 0 0 1 4 19.003v-4.006c0-.55.447-.997.997-.997h14.006c.55 0 .997.447.997.997zM4 5.002C4 4.449 4.449 4 5.001 4h13.998C19.551 4 20 4.449 20 5.002v7.169c-.083-.029-.171-.045-.256-.067-.06-.016-.119-.036-.18-.047a2.965 2.965 0 0 0-.561-.057H4.997c-.192 0-.379.022-.561.057-.061.011-.12.031-.18.047-.086.022-.173.038-.256.067zM5.001 2A3.005 3.005 0 0 0 2 5.002v14.001A3 3 0 0 0 4.997 22h14.006A3 3 0 0 0 22 19.003V5.002A3.005 3.005 0 0 0 18.999 2zM16 18h2v-2h-2zm-4 0h2v-2h-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHardrive as Hardrive };
